import moment from 'moment';

export const transformManagedIntegrationActionFiltersParamsToApi = ({
  orderNumber,
  quoteNumber,
  relatedObjectTypeIn,
  sort,
  statusIn,
  typeIn,
  updatedRange,
  page,
}) => ({
  order_number: orderNumber || undefined,
  quote_number: quoteNumber || undefined,
  related_object_type_in: relatedObjectTypeIn || undefined,
  sort:
    sort && Array.isArray(sort) && sort.length > 0 ? sort.join(',') : undefined,
  status_in:
    statusIn && Array.isArray(statusIn) && statusIn.length > 0
      ? statusIn.join(',')
      : undefined,
  type_in:
    typeIn && Array.isArray(typeIn) && typeIn.length > 0
      ? typeIn.join(',')
      : undefined,
  updated_range:
    updatedRange && Array.isArray(updatedRange) && updatedRange.length === 2
      ? `${moment(updatedRange[0]).format()},${moment(
          updatedRange[1],
        ).format()}`
      : undefined,
  page: page || undefined,
});
